import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import IllustratedBlankSlate from './IllustratedBlankSlate'
import illustration from './illustration.svg'

interface Props {
  numericalResults?: boolean
}

const BlankSlate = ({ numericalResults = false }: Props) => {
  if (numericalResults) {
    return (
      <IllustratedBlankSlate
        illustration={illustration}
        title={i18n.t('surveys.form.tabs.no_results_numerical.title')}
        description={i18n.t('surveys.form.tabs.no_results_numerical.review_description')}
      />
    )
  }

  return (
    <IllustratedBlankSlate
      illustration={illustration}
      title={i18n.t('surveys.form.tabs.no_results.title')}
      description={i18n.t('surveys.form.tabs.no_results.review_description')}
    />
  )
}

export default BlankSlate
